const SubjectTopicName = [

 {
    "_id": {
      "$oid": "68bc5a1dd600bcfb82980910"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2026",
    "topicssymbol": "2026",
    "__v": 0
  }, 
  {
    "_id": {
      "$oid": "68bc5a1dd600bcfb82980910"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2025",
    "topicssymbol": "2025",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5b3cd600bcfb829809a8"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2024",
    "topicssymbol": "2024",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5b4fd600bcfb829809be"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2023",
    "topicssymbol": "2023",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5b66d600bcfb829809c1"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2022",
    "topicssymbol": "2022",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68c54a6edd55e6bfa66db631"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2021",
    "topicssymbol": "2021",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68c54be2dd55e6bfa66db782"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2020",
    "topicssymbol": "2020",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cb75237ed62bd520fe4f89"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2019",
    "topicssymbol": "2019",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cb75357ed62bd520fe4f9a"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2018",
    "topicssymbol": "2018",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cb75437ed62bd520fe4f9d"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2017",
    "topicssymbol": "2017",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cb754d7ed62bd520fe4fa0"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2016",
    "topicssymbol": "2016",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cb75587ed62bd520fe4fa3"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "physics",
    "topicsname": "Previous year questions 2015",
    "topicssymbol": "2015",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5a05d600bcfb8298090d"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2026",
    "topicssymbol": "2026",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5a05d600bcfb8298090d"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2025",
    "topicssymbol": "2025",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5bced600bcfb829809e5"
    },
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2024",
    "topicssymbol": "2024",
    "__v": 0,
    "topicstype": "previousyearquestions"
  },
  {
    "_id": {
      "$oid": "68bc5bffd600bcfb829809f6"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2023",
    "topicssymbol": "2023",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce129d439d9b05437d5740"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2022",
    "topicssymbol": "2022",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce1320439d9b05437d5787"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2021",
    "topicssymbol": "2021",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce1336439d9b05437d578a"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2020",
    "topicssymbol": "2020",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce135b439d9b05437d578d"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2019",
    "topicssymbol": "2019",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce1376439d9b05437d5792"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2018",
    "topicssymbol": "2018",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce1385439d9b05437d5795"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2017",
    "topicssymbol": "2017",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce139b439d9b05437d5798"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2016",
    "topicssymbol": "2016",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce13af439d9b05437d579b"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "chemistry",
    "topicsname": "Previous year questions 2015",
    "topicssymbol": "2015",
    "__v": 0
  },
   {
    "_id": {
      "$oid": "68bc5c12d600bcfb82980a03"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2026",
    "topicssymbol": "2026",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5c12d600bcfb82980a03"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2025",
    "topicssymbol": "2025",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5c4ad600bcfb82980a3c"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2024",
    "topicssymbol": "2024",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce13cf439d9b05437d57a6"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2023",
    "topicssymbol": "2023",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce13da439d9b05437d57a9"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2022",
    "topicssymbol": "2022",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce13e6439d9b05437d57ac"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2021",
    "topicssymbol": "2021",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce13f3439d9b05437d57af"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2020",
    "topicssymbol": "2020",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce13fc439d9b05437d57b2"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2019",
    "topicssymbol": "2019",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce1406439d9b05437d57b5"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2018",
    "topicssymbol": "2018",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce1413439d9b05437d57b8"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2017",
    "topicssymbol": "2017",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce141d439d9b05437d57bb"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2016",
    "topicssymbol": "2016",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce142e439d9b05437d57be"
    },
    "topicstype": "previousyearquestions",
    "topicssubject": "biology",
    "topicsname": "Previous year questions 2015",
    "topicssymbol": "2015",
    "__v": 0
  },


  {
    "_id": {
      "$oid": "68bc5c74d600bcfb82980a55"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "1-Physical World, Units & Meas...",
    "topicssymbol": "CP01",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5d08d600bcfb82980a96"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "2- Motion in a Straight Line",
    "topicssymbol": "CP02",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5d1cd600bcfb82980aa3"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "3-Motion in a Plane",
    "topicssymbol": "CP03",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5d39d600bcfb82980abc"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "4- Laws of Motion",
    "topicssymbol": "CP04",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5d4dd600bcfb82980ac9"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "5- Work, Energy and Power",
    "topicssymbol": "CP05",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce970606defed6d6e14c42"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "6-System of Particles and Rotational Motion",
    "topicssymbol": "CP06",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce971706defed6d6e14c4b"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "7-Gravitation",
    "topicssymbol": "CP07",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce972306defed6d6e14c54"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "8-Mechanical Properties of Solids",
    "topicssymbol": "CP08",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce972e06defed6d6e14c5d"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "9- Mechanical Properties of Fluids",
    "topicssymbol": "CP09",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce973b06defed6d6e14c66"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "10-Thermal Properties of Matter",
    "topicssymbol": "CP10",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce977506defed6d6e14c6a"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "11-Thermodynamics",
    "topicssymbol": "CP11",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce977d06defed6d6e14c6d"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "12- Kinetic Theory",
    "topicssymbol": "CP12",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce978506defed6d6e14c70"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "13-Oscillations",
    "topicssymbol": "CP13",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce978d06defed6d6e14c73"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "14-Waves",
    "topicssymbol": "CP14",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce979506defed6d6e14c76"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "15-Electric Charges and Fields",
    "topicssymbol": "CP15",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce979e06defed6d6e14c79"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "16-Electrostatic Potential & Capacitance",
    "topicssymbol": "CP16",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce97a806defed6d6e14c7c"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "17-Current Electricity",
    "topicssymbol": "CP17",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce97af06defed6d6e14c7f"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "18-Moving Charges and Magnetism",
    "topicssymbol": "CP18",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce97b806defed6d6e14c82"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "19-Magnetism and Matter",
    "topicssymbol": "CP19",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce97c306defed6d6e14c85"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "20- Electromagnetic Induction",
    "topicssymbol": "CP20",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce97e706defed6d6e14c8b"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "21-Alternating Current",
    "topicssymbol": "CP21",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce97ee06defed6d6e14c8e"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "22-Electromagnetic Waves",
    "topicssymbol": "CP22",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce97f706defed6d6e14c91"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "23- Ray Optics and Optical Instruments",
    "topicssymbol": "CP23",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce97fd06defed6d6e14c94"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "24- Wave Optics",
    "topicssymbol": "CP24",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce981106defed6d6e14c99"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "25-Dual Nature of Radiation and Matter",
    "topicssymbol": "CP25",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce99e306defed6d6e14c9c"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "26-Atoms",
    "topicssymbol": "CP26",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce99ec06defed6d6e14c9f"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "27-Nuclei",
    "topicssymbol": "CP27",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce99f606defed6d6e14ca2"
    },
    "topicstype": "dpp",
    "topicssubject": "physics",
    "topicsname": "28- Semiconductor Electronics Materials, Devices and Simple Circuits",
    "topicssymbol": "CP28",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5d6fd600bcfb82980ae0"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "1-Some Basic Concepts of Chemistry",
    "topicssymbol": "CC01",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5d8ed600bcfb82980aff"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "2-Structure of Atom",
    "topicssymbol": "CC02",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5db6d600bcfb82980b0c"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "3-Classification of Elements and Periodicity in Properties",
    "topicssymbol": "CC03",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9a4206defed6d6e14caf"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "4-Chemical bonding and Molecular structure",
    "topicssymbol": "CC04",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9a4e06defed6d6e14cb2"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "5-States of Mater",
    "topicssymbol": "CC05",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9a5606defed6d6e14cb5"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "6-Thermodynamics",
    "topicssymbol": "CC06",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9a5e06defed6d6e14cb8"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "7-Equilibrium",
    "topicssymbol": "CC07",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9a6606defed6d6e14cbb"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "8-Redox Reactions",
    "topicssymbol": "CC08",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9a6e06defed6d6e14cbe"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "9-Hydrogen",
    "topicssymbol": "CC09",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9a7806defed6d6e14cc1"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "10-Bolck Elements",
    "topicssymbol": "CC10",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9a8a06defed6d6e14cc6"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "11-p-Bicok Elements",
    "topicssymbol": "CC11",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9a9206defed6d6e14cc9"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "12- Organic chemistry-Some basic principles and Techniques",
    "topicssymbol": "CC12",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9fb106defed6d6e14ccc"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "13-Hydrocarbons",
    "topicssymbol": "CC13",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9fb906defed6d6e14ccf"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "14- Environmental Chemistry",
    "topicssymbol": "CC14",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9fc306defed6d6e14cd2"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "15-The Solid State",
    "topicssymbol": "CC15",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9fcb06defed6d6e14cd5"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "16-Solutions",
    "topicssymbol": "CC16",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9fd406defed6d6e14cd8"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "17-Electrochemistry",
    "topicssymbol": "CC17",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9fde06defed6d6e14cdb"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "18-Chemical Kinetics",
    "topicssymbol": "CC18",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9fe606defed6d6e14cde"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "19-Surface Chemistr",
    "topicssymbol": "CC19",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68ce9ff306defed6d6e14ce1"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "20-General Principles and Processes of Isolation of Elements",
    "topicssymbol": "CC20",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea00a06defed6d6e14ce6"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "21- p-Biock Elements (Group 15, 16, 17 and 18)",
    "topicssymbol": "CC21",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea01306defed6d6e14ce9"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "22-The d-and f-Biock Elements",
    "topicssymbol": "CC22",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea01a06defed6d6e14cec"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "23-Coordination Compounds",
    "topicssymbol": "CC23",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea02306defed6d6e14cef"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "24- Haloalkanes and Haloarenes",
    "topicssymbol": "CC24",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea02c06defed6d6e14cf2"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "25-Alcohols, Phenols and Ethers",
    "topicssymbol": "CC25",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea03406defed6d6e14cf5"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "26- Aldehydes, Ketones and Carboxylic Acids",
    "topicssymbol": "CC26",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea03b06defed6d6e14cf8"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "27-Amines",
    "topicssymbol": "CC27",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea04306defed6d6e14cfb"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "28-Biomolecules",
    "topicssymbol": "CC28",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea04c06defed6d6e14cfe"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "29-Polymers",
    "topicssymbol": "CC29",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea05406defed6d6e14d01"
    },
    "topicstype": "dpp",
    "topicssubject": "chemistry",
    "topicsname": "30-Chemistry in Everyday Life",
    "topicssymbol": "CC30",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5de2d600bcfb82980b49"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "1-The Living World",
    "topicssymbol": "CB01",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68bc5df9d600bcfb82980b56"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "2-Biological Classification",
    "topicssymbol": "CB02",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68c82cc5299021b2f137bf57"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "3-Plant kingdom",
    "topicssymbol": "CB03",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68c82ce2299021b2f137bf68"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "4-Animal Kingdom",
    "topicssymbol": "CB04",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea08406defed6d6e14d0e"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "5-Morphology of Flowering Plants",
    "topicssymbol": "CB05",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea08c06defed6d6e14d11"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "6-Anatomy of Flowering Plants",
    "topicssymbol": "CB06",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea09306defed6d6e14d14"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "7-Structural Organiation in Animals",
    "topicssymbol": "CB07",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea09c06defed6d6e14d17"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "8-Cell-The Unit of Life",
    "topicssymbol": "CB08",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0a906defed6d6e14d1c"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "9-Biomolecules",
    "topicssymbol": "CB09",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0b906defed6d6e14d1f"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "10-Cell Cycle and Cell Devision",
    "topicssymbol": "CB10",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0c106defed6d6e14d22"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "11-Transport in Plants",
    "topicssymbol": "CB11",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0c906defed6d6e14d25"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "12-Mineral Nutrition",
    "topicssymbol": "CB12",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0d006defed6d6e14d28"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "13-Photosynthesis in Higer Plants",
    "topicssymbol": "CB13",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0d806defed6d6e14d2b"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "14-Respiration in Plants",
    "topicssymbol": "CB14",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0df06defed6d6e14d2e"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "15-Plant Growth and Development",
    "topicssymbol": "CB15",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0e806defed6d6e14d31"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "16-Digestion and Absorption",
    "topicssymbol": "CB16",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0f106defed6d6e14d34"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "17-Breathing and Exchange of Gases",
    "topicssymbol": "CB17",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea0f906defed6d6e14d37"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "18-Body Fluids and Circulation",
    "topicssymbol": "CB18",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea10106defed6d6e14d3a"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "19-Excretory Products and heir Elimination",
    "topicssymbol": "CB19",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea10a06defed6d6e14d3d"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "20-Locomotion and Movement",
    "topicssymbol": "CB20",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1b306defed6d6e14d42"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "21-Neural Control and Co-ordination",
    "topicssymbol": "CB21",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1bb06defed6d6e14d45"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "22-Chemical Co-ordination and Integration",
    "topicssymbol": "CB22",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1c406defed6d6e14d48"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "23-Reproduction in Organism",
    "topicssymbol": "CB23",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1cb06defed6d6e14d4b"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "24-Sexual Reproduction in Flowering Plants",
    "topicssymbol": "CB24",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1d306defed6d6e14d4e"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "25-Muman Reproduction",
    "topicssymbol": "CB25",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1da06defed6d6e14d51"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "26-Reproductive Health",
    "topicssymbol": "CB26",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1e206defed6d6e14d54"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "27-Principles of inheritance and variation",
    "topicssymbol": "CB27",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1ea06defed6d6e14d57"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "28-Molecular Basis of Inheritance",
    "topicssymbol": "CB28",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1f106defed6d6e14d5a"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "29-Evolution",
    "topicssymbol": "CB29",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea1fc06defed6d6e14d5d"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "30-Muman Health and Disease",
    "topicssymbol": "CB30",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea20906defed6d6e14d62"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "31-Strategies for Enchancement in Food Production",
    "topicssymbol": "CB31",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea21006defed6d6e14d65"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "32-Microbes in human welfare",
    "topicssymbol": "CB32",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea21706defed6d6e14d68"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "33-Biotechnology Principles and Proceses",
    "topicssymbol": "CB33",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea21f06defed6d6e14d6b"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "34-Biotechnology and its Applications",
    "topicssymbol": "CB34",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea22c06defed6d6e14d6e"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "35-Organisms and Populations",
    "topicssymbol": "CB35",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea23406defed6d6e14d71"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "36-Ecosystem",
    "topicssymbol": "CB36",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea23c06defed6d6e14d74"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "37-Biodiversity and its conservation",
    "topicssymbol": "CB37",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68cea24506defed6d6e14d77"
    },
    "topicstype": "dpp",
    "topicssubject": "biology",
    "topicsname": "38-Environmental issues",
    "topicssymbol": "CB38",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar74d6sarb82980a55"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "1-Physical World, Units & Meas...",
    "topicssymbol": "CP01",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar08d6sarb82980a96"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "2- Motion in a Straight Line",
    "topicssymbol": "CP02",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar1cd6sarb82980aa3"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "3-Motion in a Plane",
    "topicssymbol": "CP03",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar39d6sarb82980abc"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "4- Laws of Motion",
    "topicssymbol": "CP04",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar4dd6sarb82980ac9"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "5- Work, Energy and Power",
    "topicssymbol": "CP05",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar0606sar6d6e14c42"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "6-System of Particles and Rotational Motion",
    "topicssymbol": "CP06",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar1706sar6d6e14c4b"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "7-Gravitation",
    "topicssymbol": "CP07",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar2306sar6d6e14c54"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "8-Mechanical Properties of Solids",
    "topicssymbol": "CP08",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar2e06sar6d6e14c5d"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "9- Mechanical Properties of Fluids",
    "topicssymbol": "CP09",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar3b06sar6d6e14c66"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "10-Thermal Properties of Matter",
    "topicssymbol": "CP10",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar7506sar6d6e14c6a"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "11-Thermodynamics",
    "topicssymbol": "CP11",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar7d06sar6d6e14c6d"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "12- Kinetic Theory",
    "topicssymbol": "CP12",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar8506sar6d6e14c70"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "13-Oscillations",
    "topicssymbol": "CP13",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar8d06sar6d6e14c73"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "14-Waves",
    "topicssymbol": "CP14",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar9506sar6d6e14c76"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "15-Electric Charges and Fields",
    "topicssymbol": "CP15",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar9e06sar6d6e14c79"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "16-Electrostatic Potential & Capacitance",
    "topicssymbol": "CP16",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwara806sar6d6e14c7c"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "17-Current Electricity",
    "topicssymbol": "CP17",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwaraf06sar6d6e14c7f"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "18-Moving Charges and Magnetism",
    "topicssymbol": "CP18",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarb806sar6d6e14c82"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "19-Magnetism and Matter",
    "topicssymbol": "CP19",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarc306sar6d6e14c85"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "20- Electromagnetic Induction",
    "topicssymbol": "CP20",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarware706sar6d6e14c8b"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "21-Alternating Current",
    "topicssymbol": "CP21",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwaree06sar6d6e14c8e"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "22-Electromagnetic Waves",
    "topicssymbol": "CP22",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarf706sar6d6e14c91"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "23- Ray Optics and Optical Instruments",
    "topicssymbol": "CP23",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarfd06sar6d6e14c94"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "24- Wave Optics",
    "topicssymbol": "CP24",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar1106sar6d6e14c99"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "25-Dual Nature of Radiation and Matter",
    "topicssymbol": "CP25",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarware306sar6d6e14c9c"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "26-Atoms",
    "topicssymbol": "CP26",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarec06sar6d6e14c9f"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "27-Nuclei",
    "topicssymbol": "CP27",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarf606sar6d6e14ca2"
    },
    "topicstype": "mocktest",
    "topicssubject": "physics",
    "topicsname": "28- Semiconductor Electronics Materials, Devices and Simple Circuits",
    "topicssymbol": "CP28",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar6fd6sarb82980ae0"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "1-Some Basic Concepts of Chemistry",
    "topicssymbol": "CC01",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar8ed6sarb82980aff"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "2-Structure of Atom",
    "topicssymbol": "CC02",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarb6d6sarb82980b0c"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "3-Classification of Elements and Periodicity in Properties",
    "topicssymbol": "CC03",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar4206sar6d6e14caf"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "4-Chemical bonding and Molecular structure",
    "topicssymbol": "CC04",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar4e06sar6d6e14cb2"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "5-States of Mater",
    "topicssymbol": "CC05",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar5606sar6d6e14cb5"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "6-Thermodynamics",
    "topicssymbol": "CC06",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar5e06sar6d6e14cb8"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "7-Equilibrium",
    "topicssymbol": "CC07",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar6606sar6d6e14cbb"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "8-Redox Reactions",
    "topicssymbol": "CC08",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar6e06sar6d6e14cbe"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "9-Hydrogen",
    "topicssymbol": "CC09",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar7806sar6d6e14cc1"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "10-Bolck Elements",
    "topicssymbol": "CC10",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar8a06sar6d6e14cc6"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "11-p-Bicok Elements",
    "topicssymbol": "CC11",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar9206sar6d6e14cc9"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "12- Organic chemistry-Some basic principles and Techniques",
    "topicssymbol": "CC12",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarb106sar6d6e14ccc"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "13-Hydrocarbons",
    "topicssymbol": "CC13",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarb906sar6d6e14ccf"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "14- Environmental Chemistry",
    "topicssymbol": "CC14",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarc306sar6d6e14cd2"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "15-The Solid State",
    "topicssymbol": "CC15",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarcb06sar6d6e14cd5"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "16-Solutions",
    "topicssymbol": "CC16",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarward406sar6d6e14cd8"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "17-Electrochemistry",
    "topicssymbol": "CC17",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarde06sar6d6e14cdb"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "18-Chemical Kinetics",
    "topicssymbol": "CC18",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarware606sar6d6e14cde"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "19-Surface Chemistr",
    "topicssymbol": "CC19",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarf306sar6d6e14ce1"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "20-General Principles and Processes of Isolation of Elements",
    "topicssymbol": "CC20",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar0a06sar6d6e14ce6"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "21- p-Biock Elements (Group 15, 16, 17 and 18)",
    "topicssymbol": "CC21",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar1306sar6d6e14ce9"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "22-The d-and f-Biock Elements",
    "topicssymbol": "CC22",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar1a06sar6d6e14cec"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "23-Coordination Compounds",
    "topicssymbol": "CC23",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar2306sar6d6e14cef"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "24- Haloalkanes and Haloarenes",
    "topicssymbol": "CC24",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar2c06sar6d6e14cf2"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "25-Alcohols, Phenols and Ethers",
    "topicssymbol": "CC25",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar3406sar6d6e14cf5"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "26- Aldehydes, Ketones and Carboxylic Acids",
    "topicssymbol": "CC26",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar3b06sar6d6e14cf8"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "27-Amines",
    "topicssymbol": "CC27",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar4306sar6d6e14cfb"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "28-Biomolecules",
    "topicssymbol": "CC28",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar4c06sar6d6e14cfe"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "29-Polymers",
    "topicssymbol": "CC29",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar5406sar6d6e14d01"
    },
    "topicstype": "mocktest",
    "topicssubject": "chemistry",
    "topicsname": "30-Chemistry in Everyday Life",
    "topicssymbol": "CC30",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarware2d6sarb82980b49"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "1-The Living World",
    "topicssymbol": "CB01",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarf9d6sarb82980b56"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "2-Biological Classification",
    "topicssymbol": "CB02",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarc529sar2f137bf57"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "3-Plant kingdom",
    "topicssymbol": "CB03",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarware229sar2f137bf68"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "4-Animal Kingdom",
    "topicssymbol": "CB04",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar8406sar6d6e14d0e"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "5-Morphology of Flowering Plants",
    "topicssymbol": "CB05",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar8c06sar6d6e14d11"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "6-Anatomy of Flowering Plants",
    "topicssymbol": "CB06",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar9306sar6d6e14d14"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "7-Structural Organiation in Animals",
    "topicssymbol": "CB07",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar9c06sar6d6e14d17"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "8-Cell-The Unit of Life",
    "topicssymbol": "CB08",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwara906sar6d6e14d1c"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "9-Biomolecules",
    "topicssymbol": "CB09",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarb906sar6d6e14d1f"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "10-Cell Cycle and Cell Devision",
    "topicssymbol": "CB10",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarc106sar6d6e14d22"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "11-Transport in Plants",
    "topicssymbol": "CB11",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarc906sar6d6e14d25"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "12-Mineral Nutrition",
    "topicssymbol": "CB12",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarward006sar6d6e14d28"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "13-Photosynthesis in Higer Plants",
    "topicssymbol": "CB13",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarward806sar6d6e14d2b"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "14-Respiration in Plants",
    "topicssymbol": "CB14",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwardf06sar6d6e14d2e"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "15-Plant Growth and Development",
    "topicssymbol": "CB15",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarware806sar6d6e14d31"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "16-Digestion and Absorption",
    "topicssymbol": "CB16",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarf106sar6d6e14d34"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "17-Breathing and Exchange of Gases",
    "topicssymbol": "CB17",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarf906sar6d6e14d37"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "18-Body Fluids and Circulation",
    "topicssymbol": "CB18",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar0106sar6d6e14d3a"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "19-Excretory Products and heir Elimination",
    "topicssymbol": "CB19",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar0a06sar6d6e14d3d"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "20-Locomotion and Movement",
    "topicssymbol": "CB20",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarb306sar6d6e14d42"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "21-Neural Control and Co-ordination",
    "topicssymbol": "CB21",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarbb06sar6d6e14d45"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "22-Chemical Co-ordination and Integration",
    "topicssymbol": "CB22",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarc406sar6d6e14d48"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "23-Reproduction in Organism",
    "topicssymbol": "CB23",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarcb06sar6d6e14d4b"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "24-Sexual Reproduction in Flowering Plants",
    "topicssymbol": "CB24",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarward306sar6d6e14d4e"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "25-Muman Reproduction",
    "topicssymbol": "CB25",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarda06sar6d6e14d51"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "26-Reproductive Health",
    "topicssymbol": "CB26",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarware206sar6d6e14d54"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "27-Principles of inheritance and variation",
    "topicssymbol": "CB27",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarea06sar6d6e14d57"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "28-Molecular Basis of Inheritance",
    "topicssymbol": "CB28",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarf106sar6d6e14d5a"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "29-Evolution",
    "topicssymbol": "CB29",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwarfc06sar6d6e14d5d"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "30-Muman Health and Disease",
    "topicssymbol": "CB30",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar0906sar6d6e14d62"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "31-Strategies for Enchancement in Food Production",
    "topicssymbol": "CB31",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar1006sar6d6e14d65"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "32-Microbes in human welfare",
    "topicssymbol": "CB32",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar1706sar6d6e14d68"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "33-Biotechnology Principles and Proceses",
    "topicssymbol": "CB33",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar1f06sar6d6e14d6b"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "34-Biotechnology and its Applications",
    "topicssymbol": "CB34",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar2c06sar6d6e14d6e"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "35-Organisms and Populations",
    "topicssymbol": "CB35",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar3406sar6d6e14d71"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "36-Ecosystem",
    "topicssymbol": "CB36",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar3c06sar6d6e14d74"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "37-Biodiversity and its conservation",
    "topicssymbol": "CB37",
    "__v": 0
  },
  {
    "_id": {
      "$oid": "68sarwar4506sar6d6e14d77"
    },
    "topicstype": "mocktest",
    "topicssubject": "biology",
    "topicsname": "38-Environmental issues",
    "topicssymbol": "CB38",
    "__v": 0
  },


   {
    "_id": {
      "$oid": "68bc5c74d600bcfb82980a55"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "1-Physical World, Units & Meas...",
    "topicssymbol": "CP01"
  },
  {
    "_id": {
      "$oid": "68bc5d08d600bcfb82980a96"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "2- Motion in a Straight Line",
    "topicssymbol": "CP02"
  },
  {
    "_id": {
      "$oid": "68bc5d1cd600bcfb82980aa3"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "3-Motion in a Plane",
    "topicssymbol": "CP03"
  },
  {
    "_id": {
      "$oid": "68bc5d39d600bcfb82980abc"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "4- Laws of Motion",
    "topicssymbol": "CP04"
  },
  {
    "_id": {
      "$oid": "68bc5d4dd600bcfb82980ac9"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "5- Work, Energy and Power",
    "topicssymbol": "CP05"
  },
  {
    "_id": {
      "$oid": "68ce970606defed6d6e14c42"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "6-System of Particles and Rotational Motion",
    "topicssymbol": "CP06"
  },
  {
    "_id": {
      "$oid": "68ce971706defed6d6e14c4b"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "7-Gravitation",
    "topicssymbol": "CP07"
  },
  {
    "_id": {
      "$oid": "68ce972306defed6d6e14c54"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "8-Mechanical Properties of Solids",
    "topicssymbol": "CP08"
  },
  {
    "_id": {
      "$oid": "68ce972e06defed6d6e14c5d"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "9- Mechanical Properties of Fluids",
    "topicssymbol": "CP09"
  },
  {
    "_id": {
      "$oid": "68ce973b06defed6d6e14c66"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "10-Thermal Properties of Matter",
    "topicssymbol": "CP10"
  },
  {
    "_id": {
      "$oid": "68ce977506defed6d6e14c6a"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "11-Thermodynamics",
    "topicssymbol": "CP11"
  },
  {
    "_id": {
      "$oid": "68ce977d06defed6d6e14c6d"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "12- Kinetic Theory",
    "topicssymbol": "CP12"
  },
  {
    "_id": {
      "$oid": "68ce978506defed6d6e14c70"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "13-Oscillations",
    "topicssymbol": "CP13"
  },
  {
    "_id": {
      "$oid": "68ce978d06defed6d6e14c73"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "14-Waves",
    "topicssymbol": "CP14"
  },
  {
    "_id": {
      "$oid": "68ce979506defed6d6e14c76"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "15-Electric Charges and Fields",
    "topicssymbol": "CP15"
  },
  {
    "_id": {
      "$oid": "68ce979e06defed6d6e14c79"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "16-Electrostatic Potential & Capacitance",
    "topicssymbol": "CP16"
  },
  {
    "_id": {
      "$oid": "68ce97a806defed6d6e14c7c"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "17-Current Electricity",
    "topicssymbol": "CP17"
  },
  {
    "_id": {
      "$oid": "68ce97af06defed6d6e14c7f"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "18-Moving Charges and Magnetism",
    "topicssymbol": "CP18"
  },
  {
    "_id": {
      "$oid": "68ce97b806defed6d6e14c82"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "19-Magnetism and Matter",
    "topicssymbol": "CP19"
  },
  {
    "_id": {
      "$oid": "68ce97c306defed6d6e14c85"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "20- Electromagnetic Induction",
    "topicssymbol": "CP20"
  },
  {
    "_id": {
      "$oid": "68ce97e706defed6d6e14c8b"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "21-Alternating Current",
    "topicssymbol": "CP21"
  },
  {
    "_id": {
      "$oid": "68ce97ee06defed6d6e14c8e"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "22-Electromagnetic Waves",
    "topicssymbol": "CP22"
  },
  {
    "_id": {
      "$oid": "68ce97f706defed6d6e14c91"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "23- Ray Optics and Optical Instruments",
    "topicssymbol": "CP23"
  },
  {
    "_id": {
      "$oid": "68ce97fd06defed6d6e14c94"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "24- Wave Optics",
    "topicssymbol": "CP24"
  },
  {
    "_id": {
      "$oid": "68ce981106defed6d6e14c99"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "25-Dual Nature of Radiation and Matter",
    "topicssymbol": "CP25"
  },
  {
    "_id": {
      "$oid": "68ce99e306defed6d6e14c9c"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "26-Atoms",
    "topicssymbol": "CP26"
  },
  {
    "_id": {
      "$oid": "68ce99ec06defed6d6e14c9f"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "27-Nuclei",
    "topicssymbol": "CP27"
  },
  {
    "_id": {
      "$oid": "68ce99f606defed6d6e14ca2"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "physics",
    "topicsname": "28- Semiconductor Electronics Materials, Devices and Simple Circuits",
    "topicssymbol": "CP28"
  },
  {
    "_id": {
      "$oid": "68bc5d6fd600bcfb82980ae0"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "1-Some Basic Concepts of Chemistry",
    "topicssymbol": "CC01"
  },
  {
    "_id": {
      "$oid": "68bc5d8ed600bcfb82980aff"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "2-Structure of Atom",
    "topicssymbol": "CC02"
  },
  {
    "_id": {
      "$oid": "68bc5db6d600bcfb82980b0c"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "3-Classification of Elements and Periodicity in Properties",
    "topicssymbol": "CC03"
  },
  {
    "_id": {
      "$oid": "68ce9a4206defed6d6e14caf"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "4-Chemical bonding and Molecular structure",
    "topicssymbol": "CC04"
  },
  {
    "_id": {
      "$oid": "68ce9a4e06defed6d6e14cb2"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "5-States of Mater",
    "topicssymbol": "CC05"
  },
  {
    "_id": {
      "$oid": "68ce9a5606defed6d6e14cb5"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "6-Thermodynamics",
    "topicssymbol": "CC06"
  },
  {
    "_id": {
      "$oid": "68ce9a5e06defed6d6e14cb8"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "7-Equilibrium",
    "topicssymbol": "CC07"
  },
  {
    "_id": {
      "$oid": "68ce9a6606defed6d6e14cbb"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "8-Redox Reactions",
    "topicssymbol": "CC08"
  },
  {
    "_id": {
      "$oid": "68ce9a6e06defed6d6e14cbe"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "9-Hydrogen",
    "topicssymbol": "CC09"
  },
  {
    "_id": {
      "$oid": "68ce9a7806defed6d6e14cc1"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "10-Bolck Elements",
    "topicssymbol": "CC10"
  },
  {
    "_id": {
      "$oid": "68ce9a8a06defed6d6e14cc6"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "11-p-Bicok Elements",
    "topicssymbol": "CC11"
  },
  {
    "_id": {
      "$oid": "68ce9a9206defed6d6e14cc9"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "12- Organic chemistry-Some basic principles and Techniques",
    "topicssymbol": "CC12"
  },
  {
    "_id": {
      "$oid": "68ce9fb106defed6d6e14ccc"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "13-Hydrocarbons",
    "topicssymbol": "CC13"
  },
  {
    "_id": {
      "$oid": "68ce9fb906defed6d6e14ccf"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "14- Environmental Chemistry",
    "topicssymbol": "CC14"
  },
  {
    "_id": {
      "$oid": "68ce9fc306defed6d6e14cd2"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "15-The Solid State",
    "topicssymbol": "CC15"
  },
  {
    "_id": {
      "$oid": "68ce9fcb06defed6d6e14cd5"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "16-Solutions",
    "topicssymbol": "CC16"
  },
  {
    "_id": {
      "$oid": "68ce9fd406defed6d6e14cd8"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "17-Electrochemistry",
    "topicssymbol": "CC17"
  },
  {
    "_id": {
      "$oid": "68ce9fde06defed6d6e14cdb"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "18-Chemical Kinetics",
    "topicssymbol": "CC18"
  },
  {
    "_id": {
      "$oid": "68ce9fe606defed6d6e14cde"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "19-Surface Chemistr",
    "topicssymbol": "CC19"
  },
  {
    "_id": {
      "$oid": "68ce9ff306defed6d6e14ce1"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "20-General Principles and Processes of Isolation of Elements",
    "topicssymbol": "CC20"
  },
  {
    "_id": {
      "$oid": "68cea00a06defed6d6e14ce6"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "21- p-Biock Elements (Group 15, 16, 17 and 18)",
    "topicssymbol": "CC21"
  },
  {
    "_id": {
      "$oid": "68cea01306defed6d6e14ce9"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "22-The d-and f-Biock Elements",
    "topicssymbol": "CC22"
  },
  {
    "_id": {
      "$oid": "68cea01a06defed6d6e14cec"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "23-Coordination Compounds",
    "topicssymbol": "CC23"
  },
  {
    "_id": {
      "$oid": "68cea02306defed6d6e14cef"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "24- Haloalkanes and Haloarenes",
    "topicssymbol": "CC24"
  },
  {
    "_id": {
      "$oid": "68cea02c06defed6d6e14cf2"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "25-Alcohols, Phenols and Ethers",
    "topicssymbol": "CC25"
  },
  {
    "_id": {
      "$oid": "68cea03406defed6d6e14cf5"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "26- Aldehydes, Ketones and Carboxylic Acids",
    "topicssymbol": "CC26"
  },
  {
    "_id": {
      "$oid": "68cea03b06defed6d6e14cf8"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "27-Amines",
    "topicssymbol": "CC27"
  },
  {
    "_id": {
      "$oid": "68cea04306defed6d6e14cfb"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "28-Biomolecules",
    "topicssymbol": "CC28"
  },
  {
    "_id": {
      "$oid": "68cea04c06defed6d6e14cfe"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "29-Polymers",
    "topicssymbol": "CC29"
  },
  {
    "_id": {
      "$oid": "68cea05406defed6d6e14d01"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "chemistry",
    "topicsname": "30-Chemistry in Everyday Life",
    "topicssymbol": "CC30"
  },
  {
    "_id": {
      "$oid": "68bc5de2d600bcfb82980b49"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "1-The Living World",
    "topicssymbol": "CB01"
  },
  {
    "_id": {
      "$oid": "68bc5df9d600bcfb82980b56"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "2-Biological Classification",
    "topicssymbol": "CB02"
  },
  {
    "_id": {
      "$oid": "68c82cc5299021b2f137bf57"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "3-Plant kingdom",
    "topicssymbol": "CB03"
  },
  {
    "_id": {
      "$oid": "68c82ce2299021b2f137bf68"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "4-Animal Kingdom",
    "topicssymbol": "CB04"
  },
  {
    "_id": {
      "$oid": "68cea08406defed6d6e14d0e"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "5-Morphology of Flowering Plants",
    "topicssymbol": "CB05"
  },
  {
    "_id": {
      "$oid": "68cea08c06defed6d6e14d11"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "6-Anatomy of Flowering Plants",
    "topicssymbol": "CB06"
  },
  {
    "_id": {
      "$oid": "68cea09306defed6d6e14d14"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "7-Structural Organiation in Animals",
    "topicssymbol": "CB07"
  },
  {
    "_id": {
      "$oid": "68cea09c06defed6d6e14d17"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "8-Cell-The Unit of Life",
    "topicssymbol": "CB08"
  },
  {
    "_id": {
      "$oid": "68cea0a906defed6d6e14d1c"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "9-Biomolecules",
    "topicssymbol": "CB09"
  },
  {
    "_id": {
      "$oid": "68cea0b906defed6d6e14d1f"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "10-Cell Cycle and Cell Devision",
    "topicssymbol": "CB10"
  },
  {
    "_id": {
      "$oid": "68cea0c106defed6d6e14d22"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "11-Transport in Plants",
    "topicssymbol": "CB11"
  },
  {
    "_id": {
      "$oid": "68cea0c906defed6d6e14d25"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "12-Mineral Nutrition",
    "topicssymbol": "CB12"
  },
  {
    "_id": {
      "$oid": "68cea0d006defed6d6e14d28"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "13-Photosynthesis in Higer Plants",
    "topicssymbol": "CB13"
  },
  {
    "_id": {
      "$oid": "68cea0d806defed6d6e14d2b"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "14-Respiration in Plants",
    "topicssymbol": "CB14"
  },
  {
    "_id": {
      "$oid": "68cea0df06defed6d6e14d2e"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "15-Plant Growth and Development",
    "topicssymbol": "CB15"
  },
  {
    "_id": {
      "$oid": "68cea0e806defed6d6e14d31"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "16-Digestion and Absorption",
    "topicssymbol": "CB16"
  },
  {
    "_id": {
      "$oid": "68cea0f106defed6d6e14d34"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "17-Breathing and Exchange of Gases",
    "topicssymbol": "CB17"
  },
  {
    "_id": {
      "$oid": "68cea0f906defed6d6e14d37"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "18-Body Fluids and Circulation",
    "topicssymbol": "CB18"
  },
  {
    "_id": {
      "$oid": "68cea10106defed6d6e14d3a"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "19-Excretory Products and heir Elimination",
    "topicssymbol": "CB19"
  },
  {
    "_id": {
      "$oid": "68cea10a06defed6d6e14d3d"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "20-Locomotion and Movement",
    "topicssymbol": "CB20"
  },
  {
    "_id": {
      "$oid": "68cea1b306defed6d6e14d42"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "21-Neural Control and Co-ordination",
    "topicssymbol": "CB21"
  },
  {
    "_id": {
      "$oid": "68cea1bb06defed6d6e14d45"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "22-Chemical Co-ordination and Integration",
    "topicssymbol": "CB22"
  },
  {
    "_id": {
      "$oid": "68cea1c406defed6d6e14d48"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "23-Reproduction in Organism",
    "topicssymbol": "CB23"
  },
  {
    "_id": {
      "$oid": "68cea1cb06defed6d6e14d4b"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "24-Sexual Reproduction in Flowering Plants",
    "topicssymbol": "CB24"
  },
  {
    "_id": {
      "$oid": "68cea1d306defed6d6e14d4e"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "25-Muman Reproduction",
    "topicssymbol": "CB25"
  },
  {
    "_id": {
      "$oid": "68cea1da06defed6d6e14d51"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "26-Reproductive Health",
    "topicssymbol": "CB26"
  },
  {
    "_id": {
      "$oid": "68cea1e206defed6d6e14d54"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "27-Principles of inheritance and variation",
    "topicssymbol": "CB27"
  },
  {
    "_id": {
      "$oid": "68cea1ea06defed6d6e14d57"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "28-Molecular Basis of Inheritance",
    "topicssymbol": "CB28"
  },
  {
    "_id": {
      "$oid": "68cea1f106defed6d6e14d5a"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "29-Evolution",
    "topicssymbol": "CB29"
  },
  {
    "_id": {
      "$oid": "68cea1fc06defed6d6e14d5d"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "30-Muman Health and Disease",
    "topicssymbol": "CB30"
  },
  {
    "_id": {
      "$oid": "68cea20906defed6d6e14d62"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "31-Strategies for Enchancement in Food Production",
    "topicssymbol": "CB31"
  },
  {
    "_id": {
      "$oid": "68cea21006defed6d6e14d65"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "32-Microbes in human welfare",
    "topicssymbol": "CB32"
  },
  {
    "_id": {
      "$oid": "68cea21706defed6d6e14d68"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "33-Biotechnology Principles and Proceses",
    "topicssymbol": "CB33"
  },
  {
    "_id": {
      "$oid": "68cea21f06defed6d6e14d6b"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "34-Biotechnology and its Applications",
    "topicssymbol": "CB34"
  },
  {
    "_id": {
      "$oid": "68cea22c06defed6d6e14d6e"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "35-Organisms and Populations",
    "topicssymbol": "CB35"
  },
  {
    "_id": {
      "$oid": "68cea23406defed6d6e14d71"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "36-Ecosystem",
    "topicssymbol": "CB36"
  },
  {
    "_id": {
      "$oid": "68cea23c06defed6d6e14d74"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "37-Biodiversity and its conservation",
    "topicssymbol": "CB37"
  },
  {
    "_id": {
      "$oid": "68cea24506defed6d6e14d77"
    },
    "topicstype": "chapterwisepyq",
    "topicssubject": "biology",
    "topicsname": "38-Environmental issues",
    "topicssymbol": "CB38"
  },

  {
    "_id": {
      "$oid": "68bc5c74d600bcfb82980a55"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "1- Units and Measurements",
    "topicssymbol": "CP01"
  },
  {
    "_id": {
      "$oid": "68bc5d08d600bcfb82980a96"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "2- Motion in a Straight Line",
    "topicssymbol": "CP02"
  },
  {
    "_id": {
      "$oid": "68bc5d1cd600bcfb82980aa3"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "3- Motion in a Plane",
    "topicssymbol": "CP03"
  },
  {
    "_id": {
      "$oid": "68bc5d39d600bcfb82980abc"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "4- Laws of Motion",
    "topicssymbol": "CP04"
  },
  {
    "_id": {
      "$oid": "68bc5d4dd600bcfb82980ac9"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "5- Work, Energy and Power",
    "topicssymbol": "CP05"
  },
  {
    "_id": {
      "$oid": "68ce970606defed6d6e14c42"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "6-System of Particles and Rotational Motion",
    "topicssymbol": "CP06"
  },
  {
    "_id": {
      "$oid": "68ce971706defed6d6e14c4b"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "7-Gravitation",
    "topicssymbol": "CP07"
  },
  {
    "_id": {
      "$oid": "68ce972306defed6d6e14c54"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "8-Mechanical Properties of Solids",
    "topicssymbol": "CP08"
  },
  {
    "_id": {
      "$oid": "68ce972e06defed6d6e14c5d"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "9- Mechanical Properties of Fluids",
    "topicssymbol": "CP09"
  },
  {
    "_id": {
      "$oid": "68ce973b06defed6d6e14c66"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "10-Thermal Properties of Matter",
    "topicssymbol": "CP10"
  },
  {
    "_id": {
      "$oid": "68ce977506defed6d6e14c6a"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "11-Thermodynamics",
    "topicssymbol": "CP11"
  },
  {
    "_id": {
      "$oid": "68ce977d06defed6d6e14c6d"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "12- Kinetic Theory",
    "topicssymbol": "CP12"
  },
  {
    "_id": {
      "$oid": "68ce978506defed6d6e14c70"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "13-Oscillations",
    "topicssymbol": "CP13"
  },
  {
    "_id": {
      "$oid": "68ce978d06defed6d6e14c73"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "14-Waves",
    "topicssymbol": "CP14"
  },
  {
    "_id": {
      "$oid": "68ce979506defed6d6e14c76"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "15-Electric Charges and Fields",
    "topicssymbol": "CP15"
  },
  {
    "_id": {
      "$oid": "68ce979e06defed6d6e14c79"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "16-Electrostatic Potential & Capacitance",
    "topicssymbol": "CP16"
  },
  {
    "_id": {
      "$oid": "68ce97a806defed6d6e14c7c"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "17-Current Electricity",
    "topicssymbol": "CP17"
  },
  {
    "_id": {
      "$oid": "68ce97af06defed6d6e14c7f"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "18-Moving Charges and Magnetism",
    "topicssymbol": "CP18"
  },
  {
    "_id": {
      "$oid": "68ce97b806defed6d6e14c82"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "19-Magnetism and Matter",
    "topicssymbol": "CP19"
  },
  {
    "_id": {
      "$oid": "68ce97c306defed6d6e14c85"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "20- Electromagnetic Induction",
    "topicssymbol": "CP20"
  },
  {
    "_id": {
      "$oid": "68ce97e706defed6d6e14c8b"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "21-Alternating Current",
    "topicssymbol": "CP21"
  },
  {
    "_id": {
      "$oid": "68ce97ee06defed6d6e14c8e"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "22-Electromagnetic Waves",
    "topicssymbol": "CP22"
  },
  {
    "_id": {
      "$oid": "68ce97f706defed6d6e14c91"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "23- Ray Optics and Optical Instruments",
    "topicssymbol": "CP23"
  },
  {
    "_id": {
      "$oid": "68ce97fd06defed6d6e14c94"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "24- Wave Optics",
    "topicssymbol": "CP24"
  },
  {
    "_id": {
      "$oid": "68ce981106defed6d6e14c99"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "25-Dual Nature of Radiation and Matter",
    "topicssymbol": "CP25"
  },
  {
    "_id": {
      "$oid": "68ce99e306defed6d6e14c9c"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "26-Atoms",
    "topicssymbol": "CP26"
  },
  {
    "_id": {
      "$oid": "68ce99ec06defed6d6e14c9f"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "27-Nuclei",
    "topicssymbol": "CP27"
  },
  {
    "_id": {
      "$oid": "68ce99f606defed6d6e14ca2"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "physics",
    "topicsname": "28- Semiconductor Electronics Materials",
    "topicssymbol": "CP28"
  },
    {
    "_id": {
      "$oid": "68ce99f606defed6d6e14ca2"
    },
    "topicstype": "diagrsar123dquestions",
    "topicssubject": "physics",
    "topicsname": "29-Communication Sustems",
    "topicssymbol": "CP29"
  },
  {
    "_id": {
      "$oid": "68bc5d6fd600bcfb82980ae0"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "1-Some Basic Concepts of Chemistry",
    "topicssymbol": "CC01"
  },
  {
    "_id": {
      "$oid": "68bc5d8ed600bcfb82980aff"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "2-Structure of Atom",
    "topicssymbol": "CC02"
  },
  {
    "_id": {
      "$oid": "68bc5db6d600bcfb82980b0c"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "3-Classification of Elements and Periodicity in Properties",
    "topicssymbol": "CC03"
  },
  {
    "_id": {
      "$oid": "68ce9a4206defed6d6e14caf"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "4-Chemical bonding and Molecular structure",
    "topicssymbol": "CC04"
  },
  {
    "_id": {
      "$oid": "68ce9a4e06defed6d6e14cb2"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "5-States of Mater",
    "topicssymbol": "CC05"
  },
  {
    "_id": {
      "$oid": "68ce9a5606defed6d6e14cb5"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "6-P Block Elements(G- 15,16,17,18)",
    "topicssymbol": "CC06"
  },
  {
    "_id": {
      "$oid": "68ce9a5e06defed6d6e14cb8"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "7-P Block Elements(G- 13, 14)",
    "topicssymbol": "CC07"
  },
  {
    "_id": {
      "$oid": "68ce9a6606defed6d6e14cbb"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "8-Alcohols Phenols and Ethers",
    "topicssymbol": "CC08"
  },
  {
    "_id": {
      "$oid": "68ce9a6e06defed6d6e14cbe"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "9-Chemistrh in Everyday Life",
    "topicssymbol": "CC09"
  },
  {
    "_id": {
      "$oid": "68ce9a7806defed6d6e14cc1"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "10-Haloalkanes and Haloarenes",
    "topicssymbol": "CC10"
  },
  {
    "_id": {
      "$oid": "68ce9a8a06defed6d6e14cc6"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "11-S Block Elements",
    "topicssymbol": "CC11"
  },
  {
    "_id": {
      "$oid": "68ce9a9206defed6d6e14cc9"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "12-Surface Chemistry",
    "topicssymbol": "CC12"
  },
  {
    "_id": {
      "$oid": "68ce9fb106defed6d6e14ccc"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "13-Biomolecules",
    "topicssymbol": "CC13"
  },
  {
    "_id": {
      "$oid": "68ce9fb906defed6d6e14ccf"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "14-amines",
    "topicssymbol": "CC14"
  },
  {
    "_id": {
      "$oid": "68ce9fc306defed6d6e14cd2"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "15-General principles and Isolation of Metals",
    "topicssymbol": "CC15"
  },
  {
    "_id": {
      "$oid": "68ce9fcb06defed6d6e14cd5"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "16-Redox Reactions",
    "topicssymbol": "CC16"
  },
  {
    "_id": {
      "$oid": "68ce9fd406defed6d6e14cd8"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "17-d and f Block Elements",
    "topicssymbol": "CC17"
  },
  {
    "_id": {
      "$oid": "68ce9fde06defed6d6e14cdb"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "18-Hydroigen",
    "topicssymbol": "CC18"
  },
  {
    "_id": {
      "$oid": "68ce9fe606defed6d6e14cde"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "19-Solid State",
    "topicssymbol": "CC19"
  },
  {
    "_id": {
      "$oid": "68ce9ff306defed6d6e14ce1"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "20-General Organic Chemistry",
    "topicssymbol": "CC20"
  },
  {
    "_id": {
      "$oid": "68cea00a06defed6d6e14ce6"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "21-Electrochemistry",
    "topicssymbol": "CC21"
  },
  {
    "_id": {
      "$oid": "68cea01306defed6d6e14ce9"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "22-Coordination Compounds",
    "topicssymbol": "CC22"
  },
  {
    "_id": {
      "$oid": "68cea01a06defed6d6e14cec"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "23-Carboxylic Acid Derivatives",
    "topicssymbol": "CC23"
  },
  {
    "_id": {
      "$oid": "68cea02306defed6d6e14cef"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "24-Chemical Equilibrum",
    "topicssymbol": "CC24"
  },
  {
    "_id": {
      "$oid": "68cea02c06defed6d6e14cf2"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "25-Thermodynamics",
    "topicssymbol": "CC25"
  },
  {
    "_id": {
      "$oid": "68cea03406defed6d6e14cf5"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "26-Chemical Kinetics",
    "topicssymbol": "CC26"
  },
  {
    "_id": {
      "$oid": "68cea03b06defed6d6e14cf8"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "27-Aldehydes and Ketones",
    "topicssymbol": "CC27"
  },
  {
    "_id": {
      "$oid": "68cea04306defed6d6e14cfb"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "28-Plymers",
    "topicssymbol": "CC28"
  },
  {
    "_id": {
      "$oid": "68cea04c06defed6d6e14cfe"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "29-Solutions",
    "topicssymbol": "CC29"
  },
  {
    "_id": {
      "$oid": "68cea05406defed6d6e14d01"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "30-Hydrocarbons",
    "topicssymbol": "CC30"
  },
    {
    "_id": {
      "$oid": "68cea054sar123d6d6e14d01"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "chemistry",
    "topicsname": "31-Ionic Equilibrium",
    "topicssymbol": "CC31"
  },
  {
    "_id": {
      "$oid": "68bc5de2d600bcfb82980b49"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "1-body Fluids an dCirculation",
    "topicssymbol": "CB01"
  },
  {
    "_id": {
      "$oid": "68bc5df9d600bcfb82980b56"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "2-Locomotion an dMovement",
    "topicssymbol": "CB02"
  },
  {
    "_id": {
      "$oid": "68c82cc5299021b2f137bf57"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "3-Biological Classification",
    "topicssymbol": "CB03"
  },
  {
    "_id": {
      "$oid": "68c82ce2299021b2f137bf68"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "4-Human Health and Diseases",
    "topicssymbol": "CB04"
  },
  {
    "_id": {
      "$oid": "68cea08406defed6d6e14d0e"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "5-Cell - The Unit of Life",
    "topicssymbol": "CB05"
  },
  {
    "_id": {
      "$oid": "68cea08c06defed6d6e14d11"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "6-Ecosystem",
    "topicssymbol": "CB06"
  },
  {
    "_id": {
      "$oid": "68cea09306defed6d6e14d14"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "7-Chemical Coordination and Integration",
    "topicssymbol": "CB07"
  },
  {
    "_id": {
      "$oid": "68cea09c06defed6d6e14d17"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "8-Animal Kingdom",
    "topicssymbol": "CB08"
  },
  {
    "_id": {
      "$oid": "68cea0a906defed6d6e14d1c"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "9-Cell Cycle and Cell Division",
    "topicssymbol": "CB09"
  },
  {
    "_id": {
      "$oid": "68cea0b906defed6d6e14d1f"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "10-Evolution",
    "topicssymbol": "CB10"
  },
  {
    "_id": {
      "$oid": "68cea0c106defed6d6e14d22"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "11-Morphology of flowering Plants",
    "topicssymbol": "CB11"
  },
  {
    "_id": {
      "$oid": "68cea0c906defed6d6e14d25"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "12-Molecular Basis of Inheritance",
    "topicssymbol": "CB12"
  },
  {
    "_id": {
      "$oid": "68cea0d006defed6d6e14d28"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "13-Neural Control and Coordinatin",
    "topicssymbol": "CB13"
  },
  {
    "_id": {
      "$oid": "68cea0d806defed6d6e14d2b"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "14-Breathing and Exchange of Gases",
    "topicssymbol": "CB14"
  },
  {
    "_id": {
      "$oid": "68cea0df06defed6d6e14d2e"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "15-The Living World",
    "topicssymbol": "CB15"
  },
  {
    "_id": {
      "$oid": "68cea0e806defed6d6e14d31"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "16-Anatomy of flowering Plants",
    "topicssymbol": "CB16"
  },
  {
    "_id": {
      "$oid": "68cea0f106defed6d6e14d34"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "17-Biomolecules",
    "topicssymbol": "CB17"
  },
  {
    "_id": {
      "$oid": "68cea0f906defed6d6e14d37"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "18-Biodiversity and Its conservation",
    "topicssymbol": "CB18"
  },
  {
    "_id": {
      "$oid": "68cea10106defed6d6e14d3a"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "19-Mcrobesin Human Welfare",
    "topicssymbol": "CB19"
  },
  {
    "_id": {
      "$oid": "68cea10a06defed6d6e14d3d"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "20-Je,am Reproduction",
    "topicssymbol": "CB20"
  },
  {
    "_id": {
      "$oid": "68cea1b306defed6d6e14d42"
    },
    "topicstype": "diagrambasedquestions",
    "topicssubject": "biology",
    "topicsname": "21-Excretory products and Their Elimination",
    "topicssymbol": "CB21"
  },


]




export default SubjectTopicName;